import { useSyncExternalStore } from "react";

const lists = new Map<string, MediaQueryList>();
const list = (query: string): MediaQueryList => {
  let found = lists.get(query);
  if (!found) {
    found = window.matchMedia(query);
    lists.set(query, found);
  }
  return found;
};

/** Whether the window matches a media query, following it as the window changes. */
export function useMatches(query: string): boolean {
  return useSyncExternalStore(
    (changed) => {
      list(query).addEventListener("change", changed);
      return () => list(query).removeEventListener("change", changed);
    },
    () => list(query).matches,
  );
}

/** Tailwind's `md`, from below. */
const PHONE = "(max-width: 767px)";

/**
 * Whether the window is a phone's. The rail is not rendered on a phone: hidden by CSS it would
 * still read its lists and sit in the tab order behind the screen.
 */
export function usePhone(): boolean {
  return useMatches(PHONE);
}

/** The same, read once, for a loader. */
export function isPhone(): boolean {
  return list(PHONE).matches;
}
